import type { BadgeTone } from "../components/ui/Badge";

// Maps each domain's status vocabulary onto the shared semantic badge tones
// (accent = current/active, sage = finished/positive, neutral = not started,
// danger = dropped/abandoned) so the olive accent keeps its single meaning
// across books/media/places instead of being reused for every status.
const TONE_BY_STATUS: Record<string, BadgeTone> = {
  reading: "accent",
  watch: "accent",
  again: "accent",
  active: "accent",
  unread: "neutral",
  want: "neutral",
  paused: "neutral",
  read: "sage",
  finished: "sage",
  visited: "sage",
  done: "sage",
  purchased: "sage",
  dropped: "danger",
};

export function statusTone(status: string): BadgeTone {
  return TONE_BY_STATUS[status] ?? "neutral";
}
